import { AdditionalHtsType } from '@xbcb/trade-data-types';
import { HtsObject } from 'types';

export const section232AluminumInfoEffectiveDate = new Date('2023-05-10');

export const isSection232AluminumSmeltAndCastApplicableForAnyTariff: (
  htsObjects: (HtsObject | undefined)[],
  estimatedImportDate: Date | undefined,
  // Hydra master bookings carry no import date (their Transportation tab is
  // hidden), so callers pass true to go by HTS alone.
  skipImportDateCheck?: boolean,
) => boolean = (
  htsObjects,
  estimatedImportDate,
  skipImportDateCheck = false,
) => {
  return htsObjects.some((tariff) =>
    Boolean(
      containsAdditionalHtsWithSection232AluminiumType(tariff) &&
        (skipImportDateCheck ||
          estimatedImportDateIsOnOrAfterEffectiveDate(estimatedImportDate)),
    ),
  );
};

const section232AluminiumTypes = new Set([
  AdditionalHtsType.SECTION_232_ALUMINIUM,
  AdditionalHtsType.SECTION_232_METAL,
  AdditionalHtsType.SECTION_232_METAL_EXCLUSION,
]);

const containsAdditionalHtsWithSection232AluminiumType: (
  hts?: HtsObject,
) => boolean = (hts) => {
  return Boolean(
    hts?.additional?.some((additionalHts) =>
      section232AluminiumTypes.has(additionalHts?.type as AdditionalHtsType),
    ),
  );
};

const estimatedImportDateIsOnOrAfterEffectiveDate: (
  estimatedImportDate: Date | undefined,
) => boolean = (estimatedImportDate) => {
  return Boolean(
    estimatedImportDate &&
      estimatedImportDate >= section232AluminumInfoEffectiveDate,
  );
};

export const section232AluminiumTariffType =
  AdditionalHtsType.SECTION_232_ALUMINIUM;
